import { ChangeDetectionStrategy, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import * as FlatFacades from "@medsurf/flat-facades";
import * as FlatServices from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-video',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    standalone: false
})
export class VideoComponent {
  @ViewChild('videoElement', {static: false}) videoElementRef: ElementRef;

  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public mediaControlService: FlatServices.MediaControlService) {
  }

  localToggle() {
    if (!this.videoElementRef.nativeElement && !this.videoElementRef.nativeElement.paused) {
      return;
    }
    if (this.videoElementRef.nativeElement.paused === true) {
      this.videoElementRef.nativeElement.play();
    } else {
      this.videoElementRef.nativeElement.pause();
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event) {
    event.preventDefault();
  }
}
